if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super()
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this))
        this.parentElement.addEventListener("shopify:section:select", () => this.open())
        this.parentElement.addEventListener("shopify:section:deselect", () => this.close())
      }
    }

    connectedCallback() {
      this.init()
    }

    init() {
      if (window.innerWidth > 767) return
      this.toggleState = false

      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden")
      }

      this.querySelector(".button--close").addEventListener("click", this.close.bind(this))
      this.querySelector(".quick-cart-drawer__backdrop").addEventListener(
        "click",
        this.close.bind(this)
      )

      this.querySelector(".quick-cart-drawer__blocks").addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.toggleState) {
          this.close()
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          )
          const firstFocusableElement = focusableElements[0]
          const lastFocusableElement = focusableElements[focusableElements.length - 1]

          let isTabPressed = e.key === "Tab"

          if (!isTabPressed) {
            return
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault()
              lastFocusableElement.focus()
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault()
              firstFocusableElement.focus()
            }
          }
        }
      })

      this.initTriggers()
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll(".quick-cart-drawer__trigger").forEach((element) => {
          if (!element._init) {
            // Daha önce eklenmiş mi kontrol edin
            element.addEventListener("click", (event) => {
              this.fetchProductForQuickCartDrawer(event)
            })
            element._init = true // Eklenmiş olarak işaretleyin
          }
        })
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    }

    async fetchProductForQuickCartDrawer(event) {
      /** stop autoplay on quick cart trigger */
      if (event.target.closest("card-product-slider")) {
        event.target.closest("card-product-slider").slider.autoplay.stop()
        event.target.closest("card-product-slider").classList.add("product--open-on-quick-cart")
      }

      const isRecommendations = event.target.classList.contains(
        "quick-cart-drawer__trigger--recommendations"
      )

      const productCard = event.target.closest("product-card")
      let productOptions = null

      if (!isRecommendations) {
        if (!productCard) return
        // get all checked options
        productOptions = productCard.querySelectorAll('input[type="radio"]:checked, select')
      }

      const trigger = event.target.closest("[data-product-url]")
      trigger.classList.toggle("is--loading")
      try {
        const productCardResponse = await fetch(`${trigger.dataset.productUrl}/?view=quick-cart`)
        if (!productCardResponse) return

        const productCardHTML = await productCardResponse.text()
        const productCard = document.createElement("DIV")
        productCard.insertAdjacentHTML("beforeend", productCardHTML)
        if (!productCard.querySelector(".quick-cart-product")) return
        this.querySelector(".quick-cart-drawer__main").innerHTML = ""
        this.querySelector(".quick-cart-drawer__main").append(
          productCard.querySelector(".quick-cart-product")
        )

        this.sliderInstance = new Swiper(".quick-cart-drawer__media-swiper", {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: {
            enabled: true
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            }
          }
        })
      } catch (error) {
        // console.log(error);
      } finally {
        trigger.classList.toggle("is--loading")

        if (!isRecommendations) {
          // update quick cart drawer options with product options
          productOptions.forEach((productOption) => {
            // console.log(productOption);
            const quickCartDrawerOption = this.querySelector(
              `[name="${productOption.name}"][value="${productOption.value}"]`
            )
            const quickCartDrawerOptionLabel =
              quickCartDrawerOption.parentElement.parentElement.querySelector("legend")
            const quickCartDrawerOptionLabelInnerHTML = quickCartDrawerOptionLabel.innerHTML

            // before updating radio button state, remove checked attribute for specific name
            this.querySelectorAll(`[name="${productOption.name}"]`).forEach((radioInput) => {
              radioInput.removeAttribute("checked")
              radioInput.closest("li").classList.remove("checked")
            })

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute("checked", "")
              const quickCartDrawerOptionLabelSpan =
                quickCartDrawerOptionLabel.querySelector("[data-selected-variant]")
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = productOption.value
              }
            }

            // update variant id in product card with selected variant id
            this.querySelector("product-card").querySelector('input[name="id"]').value =
              productCard.querySelector('input[name="id"]').value

            // update radio button state
            if (quickCartDrawerOption) {
              quickCartDrawerOption.closest("li").classList.add("checked")
            }

            // initilise for disabled states to be checked and updated
            this.querySelector("product-card").init()
          })
        }

        // short wait before opening drawer
        setTimeout(() => {
          this.open()
        }, 500)

        // add small delay to open drawer
        // this.open();

        // update label when variant is selected
        this.querySelector(".quick-cart-drawer__main")
          .querySelectorAll(".variant-option-radio-input")
          .forEach((radioInput) => {
            radioInput.addEventListener("change", (event) => {
              const quickCartDrawerOptionLabel =
                event.target.parentElement.parentElement.querySelector("legend")
              const quickCartDrawerOptionLabelSpan =
                quickCartDrawerOptionLabel.querySelector("[data-selected-variant]")
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.value
              }

              // update variant id in product card with selected variant id
              const selectedVariantId = this.querySelector(
                ".product-card__add-to-cart--form input[name='id']"
              ).value

              // get product variants data
              const productVariantsData = this.querySelector("product-card").variantsObj
              const featuredMedia = productVariantsData.find(
                (variant) => variant.id == selectedVariantId
              )?.featured_media

              if (featuredMedia) {
                this.setActiveMedia(featuredMedia.id)
              }
            })
          })
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll("[data-media-id]")).find(
        (media) => Number(media.dataset.mediaId) === id
      )
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index))
      }
    }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open()
      } else {
        this.close()
      }
    }

    open() {
      if (window.innerWidth > 767) return

      this.toggleState = true
      document.querySelector("body").classList.add("overflow-hidden")
      const quickCartDrawer = document.querySelector(".quick-cart-drawer__blocks")
      const closeButton = quickCartDrawer.querySelector(".button--close")
      quickCartDrawer.setAttribute("tabindex", "0")
      closeButton.setAttribute("tabindex", "0")
      this.classList.add("is--open")
      this.opened()

      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      if (firstFocusableElement) firstFocusableElement.focus()

      // STAURT-112: Multi-variant logic for mobile
      if (window.innerWidth <= 767) {
        setTimeout(async () => {
          const productDataCache = {}

          document.querySelectorAll(".product-card.active").forEach(async (productCard) => {
            const handle = productCard.getAttribute("data-product-handle")
            if (!handle) return

            let product = productDataCache[handle]

            if (!product) {
              try {
                const res = await fetch(`/products/${handle}.js`)
                product = await res.json()
                productDataCache[handle] = product
              } catch (error) {
                console.error("Error fetching product:", error)
                return
              }
            } else {
              console.log("Product from cache:", product)
            }
            const drawer = document.querySelector("quick-cart-drawer")
            if (!drawer) return
            if (!product.available) {
              const fieldsets = drawer.querySelectorAll(".product__variant-options")
              fieldsets.forEach((fs) => {
                fs.style.display = "none" // force-hide instead of adding class
              })

              // Find form
              const productForm = drawer.querySelector(".product-card__add-to-cart--form")

              const productCard = drawer.querySelector(".product-card")
              if (productCard && !productCard.querySelector(".product-badge--soldout")) {
                const badge = document.createElement("div")
                badge.className = "product-badge product-badge--soldout"
                badge.textContent = "Sold Out"

                // Insert at top of product-card
                productCard.insertAdjacentElement("afterbegin", badge)
              }

              // Append Notify Me after .product-card__variants
              const variantsWrapper = drawer.querySelector(".product-card__variants")
              if (variantsWrapper) {
                let notifyBtn = drawer.querySelector(".notify-me-btn")
                if (!notifyBtn) {
                  notifyBtn = document.createElement("button")
                  notifyBtn.type = "button"
                  notifyBtn.className =
                    "notify-me-btn button button--secondary button--uppercase w-full mt-3"
                  notifyBtn.textContent = "Notify Me When Available"

                  // Insert after .product-card__variants
                  variantsWrapper.insertAdjacentElement("afterend", notifyBtn)

                  // Redirect to product page
                  notifyBtn.addEventListener("click", () => {
                    window.location.href = `/products/${handle}`
                  })
                }
              }
            } else {
              const variantList = document.querySelector(".product-card__variants--list")
              if (variantList) {
                const variantItems = variantList.querySelectorAll("li")

                // Hide first li
                if (variantItems[0]) {
                  const firstFieldset = variantItems[0].querySelector(".product__variant-options")
                  if (firstFieldset) {
                    firstFieldset.style.setProperty("display", "none", "important")
                  }
                }

                // Show second li
                if (variantItems[1]) {
                  const secondFieldset = variantItems[1].querySelector(".product__variant-options")
                  if (secondFieldset) {
                    secondFieldset.style.setProperty("display", "flex", "important")
                  }
                }
              }
            }
            const preorderMessage = productCard.getAttribute("data-preorder-message") || null

            const drawerTitleWrapper = drawer.querySelector(".product__title-wrapper")
            if (drawerTitleWrapper) {
              const [mainTitle, subTitle] = product.title.split("|").map((s) => s.trim())
              const h5 = drawerTitleWrapper.querySelector("h5")
              const h6 = drawerTitleWrapper.querySelector("h6")
              if (h5) h5.textContent = mainTitle
              if (h6) h6.textContent = subTitle || ""
            }

            const priceEl = drawer.querySelector(".product__price .price span")
            if (priceEl) priceEl.textContent = `$${(product.price / 100).toFixed(2)}`

            const productCard1 = document.querySelector("quick-cart-drawer .product-card")

            const fieldsets = productCard1.querySelectorAll(".product__variant-options")

            fieldsets.forEach(async (fieldset) => {
              const legendText = fieldset.querySelector("legend")?.textContent?.toLowerCase()
              if (!legendText) return

              if (legendText.includes("color")) {
                fieldset.classList.add("hide-color-options")
              }

              if (legendText.includes("size")) {
                fieldset.classList.add("size-options-fieldset")

                const sizeRadios = fieldset.querySelectorAll('input[type="radio"]')
                sizeRadios.forEach((radio) => (radio.checked = false))

                try {
                  let product = productDataCache[handle]
                  if (!product) {
                    const res = await fetch(`/products/${handle}.js`)
                    product = await res.json()
                    productDataCache[handle] = product
                  }

                  const sizeOptionIndex = product.options.findIndex(
                    (opt) => opt.name?.toLowerCase() === "size"
                  )

                  if (sizeOptionIndex === -1) {
                    console.warn("⚠️ Could not find 'Size' option in", product.options)
                  }

                  sizeRadios.forEach((radio) => {
                    const label = fieldset.querySelector(`label[for="${radio.id}"]`)
                    if (!label) return
                    radio.disabled = false
                    label.classList.remove("disabled")
                    label.style.opacity = "1"
                    label.style.pointerEvents = "auto"
                  })

                  // Preprocess size radios
                  sizeRadios.forEach((radio) => {
                    const label = fieldset.querySelector(`label[for="${radio.id}"]`)
                    if (!label) return

                    const sizeValue = radio.value
                    const matchedVariant = product.variants.find((v) => {
                      if (sizeOptionIndex === 0) return v.option1 === sizeValue
                      if (sizeOptionIndex === 1) return v.option2 === sizeValue
                      if (sizeOptionIndex === 2) return v.option3 === sizeValue
                      return false
                    })

                    // Disable unavailable sizes
                    if (!matchedVariant || !matchedVariant.available) {
                      radio.disabled = true
                      label.classList.add("disabled")
                      label.style.opacity = "0.4"
                      label.style.pointerEvents = "none"
                      return
                    }

                    label.addEventListener("click", async (e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      label.style.setProperty("background-color", "#000", "important")
                      label.style.setProperty("color", "#fff", "important")

                      sizeRadios.forEach((r) => (r.checked = false))
                      radio.checked = true

                      try {
                        let product = productDataCache[handle]
                        if (!product) {
                          const res = await fetch(`/products/${handle}.js`)
                          product = await res.json()

                          productDataCache[handle] = product
                        }

                        const payload = {
                          id: matchedVariant.id,
                          quantity: 1,
                          ...(preorderMessage && {
                            properties: { NOTE: preorderMessage }
                          })
                        }

                        await fetch("/cart/add.js", {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json"
                          },
                          body: JSON.stringify(payload)
                        })

                        const drawer = document.querySelector("quick-cart-drawer")
                        if (drawer?.classList.contains("is--open")) {
                          drawer.classList.remove("is--open")
                        }

                        showAddedToCartPopup({
                          title: product.title,
                          image: product.featured_image,
                          price: matchedVariant.price,
                          size: sizeValue
                        })

                        const cartDrawer = document.querySelector("cart-drawer")
                        if (cartDrawer) {
                          updateCartCounters()

                          const cartRes = await fetch("/cart.js")
                          const cartState = await cartRes.json()

                          const sections = [
                            {
                              id: "#CartDrawer",
                              section: "cart-drawer",
                              selector: ".cart-drawer__inner"
                            },
                            {
                              id: "#cart-icon-bubble",
                              section: "cart-icon-bubble",
                              selector: "#cart-icon-bubble"
                            }
                          ]

                          const response = { sections: {} }

                          for (let sec of sections) {
                            const res = await fetch(
                              `${window.location.pathname}?section_id=${sec.section}`
                            )
                            const html = await res.text()
                            response.sections[sec.section] = html
                          }

                          cartDrawer.renderContents(response, false)
                        }
                      } catch (error) {
                        console.error("Error adding product to cart:", error)
                        alert("Something went wrong. Please try again.")
                      }
                    })
                  })
                } catch (error) {
                  console.error("Error fetching product:", error)
                }
              }
            })

            const drawerQtyInput = drawer.querySelector('input[name="quantity"]')
            if (drawerQtyInput) drawerQtyInput.value = 1
          })

          function showAddedToCartPopup(product) {
            const popup = document.getElementById("added-to-cart-popup")
            if (!popup) return
            const cleanTitle = product.title.split("|")[0].trim()

            popup.querySelector(".popup-product-image").src = product.image || ""
            popup.querySelector(".popup-product-title").textContent = cleanTitle || "Product"
            popup.querySelector(".popup-product-size").textContent = product.size
              ? `Size: ${product.size}`
              : ""

            const formattedPrice = formatMoney(product.price)

            popup.querySelector(".popup-product-price").textContent = formattedPrice

            popup.classList.remove("hidden")

            setTimeout(() => {
              popup.classList.add("hidden")
              document.body.classList.remove("overflow-hidden")
            }, 3000)
          }

          const closeBtn = document.querySelector(".popup-close")
          if (closeBtn) {
            closeBtn.addEventListener("click", () => {
              const popupEl = document.getElementById("added-to-cart-popup")
              popupEl?.classList.add("hidden")
              document.body.classList.remove("overflow-hidden")
            })
          }
        }, 100)
      }
      /* staurt 112 */
    }

    close() {
      this.toggleState = false

      const shopTheLookDrawer = document.querySelector("shop-the-look-drawer")

      if (shopTheLookDrawer && !shopTheLookDrawer.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden")
      }
      if (!shopTheLookDrawer) {
        document.querySelector("body").classList.remove("overflow-hidden")
      }
      this.classList.remove("is--open")
      this.closed()
      this.toggleAriaExpanded()

      /** start autoplay on quick cart drawe close */
      if (document.querySelector("card-product-slider.product--open-on-quick-cart")) {
        document
          .querySelector("card-product-slider.product--open-on-quick-cart")
          .slider.autoplay.start()
        document
          .querySelector("card-product-slider.product--open-on-quick-cart")
          .classList.remove("product--open-on-quick-cart")
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target.closest("button").setAttribute("aria-expanded", true)
        this.querySelector(".button--close").setAttribute("aria-expanded", true)
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach((button) => {
          button.setAttribute("aria-expanded", false)
        })
      }
    }

    opened() {
      const openedEvent = new Event("opened", { bubbles: true })
      this.dispatchEvent(openedEvent)
    }

    closed() {
      const closedEvent = new Event("closed", { bubbles: true })
      this.dispatchEvent(closedEvent)
    }
  }

  customElements.define("quick-cart-drawer", QuickCartDrawer)
}
